import { atomWithStorage } from 'jotai/utils';

export const ACCOUNTS_STORAGE_KEY = 'precifield.ghostAccounts';
export const accountsAtom = atomWithStorage<number[]>(ACCOUNTS_STORAGE_KEY, []);
